import clsx from 'clsx';
import type { CSSProperties } from 'react';
import { memo, useMemo } from 'react';

import { useTicketingOptions } from '../../../store';
import { demandLevelConfig } from '../../../utils/data';

import { useTranslateFn } from '@shared/Translate';
import { DEMAND_LEVEL } from '@shared-types/ticketing.types';

import * as styles from './styles.module.scss';

export const DemandLabel = memo(({ level }: { level: DEMAND_LEVEL }) => {
  const {
    options: { demandTags },
  } = useTicketingOptions();
  const t = useTranslateFn();

  const color = useMemo(
    () => (demandLevelConfig[level] ?? demandLevelConfig[DEMAND_LEVEL.NOT_AVAILABLE])?.color,
    [level],
  );

  return (
    demandTags?.[level.toLowerCase()] && (
      <div
        className={clsx(styles.demand, styles[`demand--${level.toLowerCase()}`])}
        style={
          {
            '--demand-bg-color': `var(--pk-${color})`,
          } as CSSProperties
        }
      >
        {t(demandTags[level.toLowerCase()])}
      </div>
    )
  );
});
DemandLabel.displayName = 'Label';

const Legend = () => (
  <div className='pk-col pk-col--span-12 pk-d--flex pk-justify-content--between pk-justify-content-sm--start pk-gap--l'>
    <div className={styles.column}>
      <DemandLabel level={DEMAND_LEVEL.LOW} />
      <DemandLabel level={DEMAND_LEVEL.HIGH} />
    </div>
    <div className={styles.column}>
      <DemandLabel level={DEMAND_LEVEL.VERY_HIGH} />
      <DemandLabel level={DEMAND_LEVEL.NOT_AVAILABLE} />
    </div>
  </div>
);

export default memo(Legend);
